<template>
  <div v-if="question.isSelect || question.isRadio || question.isCheckbox">
    <RevTag
      v-if="question.tag"
      class="mb-12"
      :label="question.tag"
      variant="primary"
    />
    <h3 class="heading-3 mb-12">
      {{ question.title }}
    </h3>

    <QuestionsFormItemText v-if="question.showInfo" :info="question.info" />

    <RevInputSelect
      v-if="question.isSelect"
      :id="question.key"
      class="mt-8"
      :data-qa="question.key"
      :label="question.placeholder || ''"
      :model-value="typeof question.value === 'string' ? question.value : ''"
      :options="question.options"
      @update:model-value="
        (val) =>
          emit('answer', question.key, typeof val === 'string' ? val : '')
      "
    />

    <QuestionsFormRadioInput
      v-if="question.isRadio"
      :question
      :radio-model="Array.isArray(question.value) ? false : question.value"
      @answer="(key, value) => emit('answer', key, value)"
    />

    <QuestionsFormCheckbox
      v-if="question.isCheckbox"
      :checkbox-model="question.value"
      :question
      @answer="(key, value) => emit('answer', key, value)"
    />

    <div
      v-if="question.infoBlock"
      class="text-action-default-low body-2 my-8 flex flex-col gap-8"
    >
      <p v-for="text in question.infoBlock.paragraphs" :key="text">
        {{ text }}
      </p>
    </div>
  </div>
  <div v-else-if="question.isConfirmation">
    <QuestionsFormConfirmation
      v-if="question.isConfirmation"
      :question
      @answer="(key, value) => emit('answer', key, value)"
    />
  </div>
</template>

<script setup lang="ts">
import { RevInputSelect } from '@ds/components/InputSelect'
import { RevTag } from '@ds/components/Tag'

import type { RenderQuestion } from '~/scopes/buyback/composables/useFunnelQuestions'

import QuestionsFormCheckbox from './QuestionsFormCheckbox.vue'
import QuestionsFormConfirmation from './QuestionsFormConfirmation.vue'
import QuestionsFormItemText from './QuestionsFormItemText.vue'
import QuestionsFormRadioInput from './QuestionsFormRadioInput.vue'

defineProps<{
  question: RenderQuestion
}>()

const emit = defineEmits<{
  (event: 'answer', key: string, value: string | string[] | false): void
}>()
</script>
